import { isOperatorMe } from '@/lib/api/financial/digital-account-api'
import { useEffect, useState } from 'react'

interface State {
    loading: boolean
    isOperator: boolean
    hasOperators: boolean
}

/**
 * Verifica se o usuário autenticado é operador financeiro eleito da company
 * atual. Quando ainda não há operadores eleitos (`hasOperators=false`),
 * `isOperator` retorna true (bootstrap — qualquer admin com permission pode
 * agir até o primeiro operador ser definido).
 */
export function useIsFinanceOperator(): State {
    const [state, setState] = useState<State>({
        loading: true,
        isOperator: false,
        hasOperators: false,
    })

    useEffect(() => {
        let cancelled = false
        isOperatorMe()
            .then((res) => {
                if (cancelled) return
                if (res.success && res.result) {
                    setState({
                        loading: false,
                        isOperator: res.result.isOperator,
                        hasOperators: res.result.hasOperators,
                    })
                } else {
                    setState({ loading: false, isOperator: false, hasOperators: false })
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setState({ loading: false, isOperator: false, hasOperators: false })
                }
            })
        return () => {
            cancelled = true
        }
    }, [])

    return state
}
